import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  standalone: false
})
export class PageHeaderComponent {
  @Input() pageTitle = '';
  @Input() backLabel = '';
  @Output() back = new EventEmitter<void>();

  readonly backIcon = faArrowLeft;
}